import { LOCAL_STORAGE_DOC_FLOW_COMBINING_PHASE_ASYNC_ACTION_IN_PROGRESS } from '../../constants/storage'
import { getStorageItem, setStorageItem } from '../../utils/storage'

export function getStorageCombiningPhaseAsyncStatus() {
  return getStorageItem(
    LOCAL_STORAGE_DOC_FLOW_COMBINING_PHASE_ASYNC_ACTION_IN_PROGRESS
  )
}

export function isStorageCombiningPhaseAsync() {
  return getStorageCombiningPhaseAsyncStatus() === 'true'
}

export function setStorageCombiningPhaseAsyncStatus(value) {
  return setStorageItem(
    LOCAL_STORAGE_DOC_FLOW_COMBINING_PHASE_ASYNC_ACTION_IN_PROGRESS,
    value
  )
}
